__turbopack_context__.v({
  "extra": "ExtraQuestions-module-scss-module__6CWpka__extra",
  "extra__link": "ExtraQuestions-module-scss-module__6CWpka__extra__link",
  "extra__text": "ExtraQuestions-module-scss-module__6CWpka__extra__text",
});
